export default __webpack_public_path__ + "static/media/goiCuocHeadVinaphone.b390554b.svg";